var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "battery-store__nav-row h-center-align" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.nextStep($event)
            }
          }
        },
        [_vm._v("Edit Order Info")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid battery-order-form__row battery-order-form__row--header battery-order-form__row--error"
      },
      [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__cell battery-order-view__cell--header"
          },
          [_vm._v("Order Error")]
        ),
        _vm._v(" "),
        _c("div")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel" }, [
      _c("div", { staticClass: "css-grid battery-order-form__row" }, [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "battery-order__message battery-order__message--error"
          },
          [
            _vm._v(
              "\n        Transaction failed, please update order information and try again. If problem persists, please contact your regional team for assistance.\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("div")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }